import React from 'react';

import { stopPropagation, preventDefault } from 'utils/event-handlers';
import BootstrapPopover from 'praece-react-bootstrap/lib/Popover';
import Overlay from 'praece-react-bootstrap/lib/Overlay';
import SVG from 'components/widgets/icons/svg';


export default class Popover extends React.Component {
  static defaultProps = {
    placement: 'top'
  };

  constructor() {
    super();

    this.state = { showPopover: false };

    this.show = () => this.setState({ showPopover: true });
    this.hide = () => this.setState({ showPopover: false });
  }

  render() {
    const { children, title, trigger, id, className, placement, ...props } = this.props;
    const { showPopover } = this.state;

    const header = (
      <div className="w-100 d-flex">
        <span className="p-1">{title}</span>
        <SVG onClick={this.hide} className="close" src="svg/close.svg" />
      </div>
    );

    return (
      <div onClick={stopPropagation()}>
        { trigger && <div onClick={stopPropagation(preventDefault(this.show))}>{trigger}</div> }
        <Overlay
          show={showPopover}
          placement={placement}
          target={this}
          onHide={this.hide}
          {...props}
        >
          <BootstrapPopover
            id={id}
            title={header}
            className={className}
            style={{ overflow: 'hidden' }}
            onClick={stopPropagation()}
            onMouseOver={stopPropagation()}
          >
            {children}
          </BootstrapPopover>
        </Overlay>
      </div>
    );
  }
}
